// MATERIAL
import {
  Accordion as MuiAccordion,
  accordionClasses,
  accordionSummaryClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Accordion = styled(MuiAccordion)(({ theme }) => ({
  overflow: "hidden",
  [`&.${accordionClasses.expanded}`]: {
    borderRadius: 15,
  },

  [`& .${accordionSummaryClasses.root}`]: {
    minHeight: 71,
  },

  [`& > .${accordionSummaryClasses.root}`]: {
    [`&.${accordionSummaryClasses.focusVisible}`]: {
      border: `1px solid ${theme.palette.secondary.main}`,
      backgroundColor: theme.palette.background.paper,
      borderRadius: 15,
    },
  },

  transition: "all 300ms ease",

  "&:first-of-type": {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },
  "&:last-of-type": {
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
  },
}));
